var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionLoading } from "./actionLoading";
var initial = {
    bundles: {},
};
export var reducerLoading = function (state, action) {
    if (state === void 0) { state = initial; }
    var _a;
    switch (action.type) {
        case TypeActionLoading.Start:
        case TypeActionLoading.Progress:
        case TypeActionLoading.Complete:
        case TypeActionLoading.Error:
            return {
                bundles: __assign({}, state.bundles, (_a = {}, _a[action.bundleId] = {
                    bundleId: action.bundleId,
                    hasError: action.hasError,
                    isLoaded: action.isLoaded,
                    progress: action.progress,
                }, _a)),
            };
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/loading/reducerLoading.ts
// module id = 2545
// module chunks = 3